import React from 'react';
import PrivateRoute from './PrivateRoute';
import AdminRoutes from './AdminRoutes';
import CompanyRoutes from './CompanyRoutes';
import { Route, Switch} from 'react-router-dom';
import  Content  from '../pages/App/Home/Content';
import  JobListing  from '../components/JobListing';
import  JobDetail  from '../components/JobDetail';
import Login from '../pages/App/Login/Login';
import Profile from '../pages/App/Profile/Profile';
import BackendLogin from '../pages/Backend/BackendLogin/BackendLogin';
import AdminLogin from '../pages/Admin/Admin-Login/AdminLogin';
import Signup  from '../pages/App/Signup/Signup';
import DashboardAdmin from '../pages/Admin/Admin-Dashboard/DashboardAdmin';
import BackendMain from '../pages/Backend/BackendMain/BackendMain';

const App = (props) => (
    <Switch>
        <Route {...props} path="/" exact component={Content}/>
        <Route {...props} exact path="/login" component={Login}/>
        <Route {...props} exact path="/signup" component={Signup}/>
        <Route {...props} exact path="/management" component={AdminLogin}/>
        <Route {...props} exact path="/company" component={BackendLogin}/>
        {/* PRIVATED ROUTES */}
        <PrivateRoute {...props} path="/jobdetail/:id" component={JobDetail} />
        <PrivateRoute {...props} path="/joblisting" component={JobListing} />
        <PrivateRoute {...props} path="/profile" component={Profile} />
        {/* ADMIN ROUTES */}
        <AdminRoutes {...props} path="/management/" component={DashboardAdmin}/>
        {/* COMPANY ROUTES */}
        <CompanyRoutes {...props}  path="/company/" component={BackendMain}/>
    </Switch>
)

export default App;